export const apologyMessage = "We are sorry.";
export const verificationErrorMessage = "We have trouble verifying your information.";
export const contactSupportMessage =
  "Please ensure you entered your information correctly or contact Customer Support at 1-877-MET-DDS9 (1-877-638-3379) 8 AM - 8 PM EST.";
export const systemTimeoutMessage = "The system has timed out due to a technical error.";
export const retryErrorMessage =
  "Please try again later or contact Customer Support at 1-877-MET-DDS9 (1-877-638-3379) 8 AM - 8 PM EST.";

export const buttonText = 'Go BACK TO A PREVIOUS PAGE';